import axios from 'axios';

export default axios.create({
  /**
   * URL
   */
  baseURL: 'https://tys-count.mmandb-staging.co.uk',
  headers: {
    'Content-type': 'application/json',
  },
});
